import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const styles = {
	card: {
		minWidth: 275
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)'
	},
	title: {
		marginBottom: 16,
		fontSize: 14
	},
	pos: {
		marginBottom: 12
	}
};

const options = {
	legend: {
		display: false
	},
	scales: {
		yAxes: [
			{
				ticks: {
					beginAtZero: true,
					callback: value => {
						if (Number.isInteger(value)) {
							return value;
						}
						return null;
					},
					fontColor: '#afb4c1',
					fontFamily: 'Geist Sans, sans-serif',
					fontStyle: 'bold'
				}
			}
		],
		xAxes: [
			{
				ticks: {
					fontColor: '#afb4c1',
					fontFamily: 'Geist Sans, sans-serif',
					fontStyle: 'bold'
				}
			}
		]
	},
	maintainAspectRatio: false
};

const formatReviewChart = (monthlyReviewTotals, monthlyReviewLabels) => {
	if (monthlyReviewLabels && monthlyReviewLabels) {
		return {
			labels: monthlyReviewLabels,

			datasets: [
				{
					data: monthlyReviewTotals,
					fill: false,
					borderWidth: 2,
					borderColor: '#c655d6'
				}
			]
		};
	}
	return {
		labels: [
			'JAN',
			'FEB',
			'MAR',
			'APR',
			'MAY',
			'JUN',
			'JUL',
			'AUG',
			'SEP',
			'OCT',
			'NOV',
			'DEC'
		],

		datasets: [
			{
				data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
				fill: false,
				borderWidth: 2,
				borderColor: '#c655d6'
			}
		]
	};
};

class MonthlyReviewChart extends Component {
	makeDataSet = reviewData => {
		if (reviewData) {
			const slicedReviewData = reviewData.slice(0, 20);
			const labels = slicedReviewData.map(d => d.date);
			const data = slicedReviewData.map(d => d.totalReviewCount);
			const reviewChartData = formatReviewChart(data, labels);
			return reviewChartData;
		}
		return formatReviewChart('data', 'labels');
	};

	renderBarChart = () => {
		if (this.props.reviewsByMonth) {
			return (
				<Bar
					data={this.makeDataSet(this.props.reviewsByMonth)}
					options={options}
					height={230}
				/>
			);
		}
		return null;
	};

	render() {
		const { classes } = this.props;
		return (
			<div>
				<Card zdepth={1} style={{ marginTop: 6, maxHeight: 358 }}>
					<CardContent>
						<Typography
							className={classes.title}
							variant="headline"
							color="textSecondary"
						>
							Total Reviews (All Time)
						</Typography>
						{this.renderBarChart()}
					</CardContent>
				</Card>
			</div>
		);
	}
}
export default withStyles(styles)(MonthlyReviewChart);



// WEBPACK FOOTER //
// ./src/components/review/ReviewTable/Modal/MonthlyReviewChart.js